import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import InputField from "../../components/Form/InputField";
import ImageUploader from "../../components/Form/ImageUploader";
import TextInput from "../../components/Form/TextInput";
import {toPersianNumbers} from "../../utils/toPersianNumbers";
import Button from "../../components/Button";

export default function AdminProfileEdit ()  {
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // --- گرفتن پروفایل کاربر فعلی ---
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/user-login/");
        return;
      }

      try {
        const response = await api.get(`/accounts/admin/profile/`);
        setProfile(response.data);
        setFormData(response.data);

        if (response.data.profile_picture) {
          setProfileImagePreview(response.data.profile_picture);
        }
      } catch (error) {
        console.error("خطا در گرفتن پروفایل:", error);
        if (error.response?.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("role");
          navigate("/user-login/");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  // --- تغییر فیلدها ---
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // --- ارسال فرم ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const submitData = new FormData();
      const textFields = ['full_name','title', 'description','education', 'department','national_id',
        'birth_date', 'secondary_phone','direct_manager','start_date'];

      textFields.forEach(key => {
      if (formData[key] !== null && formData[key] !== undefined) {
        const value = typeof formData[key] === "boolean" ? formData[key] : formData[key] || '';
        submitData.append(key, value);
      }
    });
      if (profileImage instanceof File) {
        submitData.append('profile_picture', profileImage);
      } else if (formData.profile_picture === null) {
        submitData.append('profile_picture', '');
      }

      await api.put(`/accounts/admin/profile/`, submitData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert("پروفایل با موفقیت ویرایش شد");
      navigate("/admin-panel/profile/");
    } catch (error) {
      console.error("خطا در ذخیره پروفایل:", error);
      console.error("داده‌های خطا:", error.response?.data);
      alert("خطا در ذخیره اطلاعات. لطفاً دوباره تلاش کنید.");
    }
  };

  if (loading) return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg text-gray-600">در حال بارگذاری...</p>
    </div>
  );

  // --- نمایش فرم ---
  return (
    <div className="p-6">
      <form onSubmit={handleSubmit} className="space-y-8">
        {/* بخش عکس پروفایل */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">عکس پروفایل</h3>
          <div className="flex items-center gap-6">
            <div className="relative">
              <ImageUploader
                imageUrl={profile.profile_picture}
                onChange={(file) => {
                setFormData({ ...formData, profile_picture: file });
                setProfileImage(file);
                }}
              />
            </div>
          </div>
        </div>

        <TextInput
          label="توضیحات"
          name="description"
          placeholder="درباره خود و فعالیت‌هایتان بنویسید..."
          value={formData.description || ""}
          onChange={(value) => setFormData((prev) => ({ ...prev, description: value }))}
        />

       {/* اطلاعات اصلی */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">اطلاعات اصلی</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <InputField
                label="نام و نام خانوادگی*"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder={profile.full_name || 'نام و نام خانوادگی خود را وارد کنید'}
            />
            <InputField
                label="عنوان"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder={profile.title || 'عنوان خود را وارد کنید'}
            />
            <InputField
                label="کد ملی"
                name="national_id"
                value={formData.national_id}
                onChange={handleChange}
                placeholder={profile.national_id || 'کد ملی خود را وارد کنید'}
            />
            <InputField
                label="تاریخ تولد"
                name="birth_date"
                type="date"
                value={formData.birth_date}
                onChange={handleChange}
                placeholder={profile.birth_date || 'تاریخ تولد خود را وارد کنید'}
            />
            <InputField
                label="تحصیلات"
                name="education"
                value={formData.education}
                onChange={handleChange}
                placeholder={profile.education || 'تحصیلات خود را وارد کنید'}
            />
            <InputField
                label="دپارمان"
                name="department"
                value={formData.department}
                onChange={handleChange}
                placeholder={profile.department || 'دپارتمان خود را وارد کنید'}
            />

            <InputField
                label="مدیر مستقیم"
                name="direct_manager"
                value={toPersianNumbers(formData.direct_manager)}
                onChange={handleChange}
                placeholder={toPersianNumbers(profile.direct_manager) || 'مدیر مستقیم خود را وارد کنید'}
            />
            <InputField
                label="شماره موبایل دوم"
                name="secondary_phone"
                value={toPersianNumbers(formData.secondary_phone)}
                onChange={handleChange}
                placeholder={toPersianNumbers(profile.secondary_phone) || 'شماره موبایل دوم خود را وارد کنید'}
            />
            <InputField
                  label="تاریخ شروع به کار"
                  name="start_date"
                  type="date"
                  value={formData.start_date}
                  onChange={handleChange}
                  placeholder={profile.start_date || 'تاریخ شروع به کار خود را وارد کنید'}
                />
          </div>
        </div>

        {/* دکمه‌های اقدام */}
        <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
          <Button children={'ذخیره تغییرات'} type='submit'/>
          <Button children={'انصراف'} variant='secondary' onClick={() => navigate("/admin-panel/profile/")}/>
        </div>
      </form>
    </div>
  );
};



